import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=66487bd4&scoped=true&"
import script from "./AddProperty.vue?vue&type=script&lang=js&"
export * from "./AddProperty.vue?vue&type=script&lang=js&"
import style0 from "./AddProperty.vue?vue&type=style&index=0&id=66487bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66487bd4",
  null
  
)

export default component.exports